import { motion, useReducedMotion } from 'motion/react';

/** Shared selection continuity, inspired by beUI. Appearance stays in FD tokens. */
export function SelectionIndicator({ id, navigation = false }: { id: string; navigation?: boolean }) {
  const reduce = useReducedMotion();
  return <motion.span
    aria-hidden="true"
    className={navigation ? 'fd-selection-indicator fd-selection-indicator--nav' : 'fd-selection-indicator'}
    layoutId={reduce ? undefined : id}
    initial={false}
    transition={reduce ? { duration: 0 } : { type: 'spring', stiffness: 245, damping: 36, mass: 1.2 }}
  />;
}
